import React from 'react';
import CoursesSection from 'containers/Overview/Sections/Courses';

var Courses = function Courses() {
  return /*#__PURE__*/React.createElement("div", {
    className: "overview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section",
    style: {
      padding: 0,
      margin: 0,
      border: 0
    }
  }, /*#__PURE__*/React.createElement(CoursesSection, null)));
};

export default Courses;